import React from 'react';

import { Resolver } from 'craft/types';

import { RTENode } from '../RTENode';

export const List: Resolver = (props: any) => {
  const variant = props.element.data?.variant ?? 'UL';

  return <RTENode is={variant} {...props} />;
};
